var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth-wrapper"},[_c('amplify-authenticator',{attrs:{"auth-config":_vm.authCredentials}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }